
<template>
  <div class="step-form forget-pwd">
    <a-steps class="steps" :current="currentStep" :status="stepStatus">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>

    <a-form class="content" :form="form">
      <template v-if="currentStep===0">
        <a-form-item v-bind="$store.state.step_ItemLayout" label="手机号" has-feedback>
          <a-input v-decorator="['mobile', decoratorOptions.mobile]" placeholder="请输入手机号"/>
        </a-form-item>

        <a-form-item class="row-form-item" v-bind="$store.state.step_ItemLayout" label="验证码" required>
          <a-form-item has-feedback>
            <a-input v-decorator="['smscode', decoratorOptions.smscode]" placeholder="请输入验证码"/>
          </a-form-item>
          <a-form-item>
            <a-button @click="getCode">{{second && `${second}S`}} 获取验证码</a-button>
          </a-form-item>
        </a-form-item>
      </template>

      <template v-if="currentStep===1">
        <a-form-item v-bind="$store.state.step_ItemLayout" label="密码">
          <a-input-password v-decorator="['password', decoratorOptions.password]" placeholder="请输入密码"/>
        </a-form-item>

        <a-form-item v-bind="$store.state.step_ItemLayout" label="确认密码">
          <a-input-password v-decorator="['repassword', decoratorOptions.repassword]" placeholder="请输入确认密码"/>
        </a-form-item>
      </template>

      <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
        <div class="steps-action">
          <a-button v-if="currentStep < steps.length - 2" type="primary" @click="next" size="large">下一步</a-button>
          <a-button v-if="currentStep === steps.length - 2" type="primary" @click="handleSubmit" size="large">确定</a-button>
          <a-button v-if="currentStep>0" :style="{marginLeft: '8px'}" @click="prev" size="large">上一步</a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
export default {
  name: 'forgetPwd',
  data () {
    return {
      second: '',
      mobileVal: {},
      currentStep: 0,
      stepStatus: 'process',
      steps: [{ title: '验证身份' }, { title: '重置密码' }, { title: '完成' }],
      decoratorOptions: {
        mobile: {
          rules: [
            { required: true, message: '请输入手机号' },
            { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
          ]
        },
        smscode: {
          rules: [{ required: true, message: '请输入验证码' }]
        },
        password: {
          rules: [
            { required: true, message: '请输入密码' },
            { pattern: this.REG.passWord, message: this.MESSAGE.passWord }
          ]
        },
        repassword: {
          rules: [
            {required: true, message: '请输入确认密码'},
            {validator: this.samePassword}
          ]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  methods: {
    /* 获取验证码 */
    getCode () {
      this.form.validateFields(['mobile'], (err, values) => {
        if (err || this.second > 0) { return; }
        this.$get({
          url: '/user/get_smscode/forget_password',
          params: values
        }).then((res) => {
          this.$message.success('验证码获取成功！');
          this.second = 60;
          let countDown = setInterval(() => {
            if (this.second > 1) {
              this.second--;
            } else {
              clearInterval(countDown);
              this.second = '';
            }
          }, 1000);
        });
      });
    },
    /* 下一步 */
    next () {
      this.form.validateFields(['mobile', 'smscode'], (err, values) => {
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.stepStatus = 'process';
          values = Object.assign(values, {type: 'forget_password'});
          this.mobileVal.mobile = values.mobile;
          console.log('mobile: ', this.mobileVal);
          this.$post({
            url: '/forget_password',
            params: values
          }).then((res) => {
            this.currentStep++;
          });
        }
      });
    },
    /* 上一步 */
    prev () {
      this.currentStep--;
    },
    /* 表单提交 */
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        values = {...values, ...this.mobileVal};
        if (err) {
          this.stepStatus = 'error';
          return false;
        } else {
          this.stepStatus = 'finish';
          this.$put({
            url: '/reset_password',
            params: values
          }).then((res) => {
            this.$message.success('重置成功！').then((res) => {
              this.openKeys = ['0'];
              this.selectedKeys = ['0-0'];
              this.userInfo = {};
              this.menuList = [];
              this.aliveComponent = [];
              localStorage.clear();
              sessionStorage.clear();
              this.$router.push({ name: 'login' });
            });
          });
        }
      });
    },
    samePassword (rule, value, callback) {
      let pwdVal = this.form.getFieldValue('password');
      if (value !== pwdVal) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/forgetPwd.vue